import * as React from "react"
import Layout from '../components/layout'

const Index = () => {
  return (
    <Layout>
      <div className="container-xl my-5 pb-5">
        
        {/* Tarjeta de Bienvenida Principal */}
        <div className="card border-0 shadow-lg text-white mb-5" style={{ 
          background: 'linear-gradient(135deg, rgba(26, 54, 93, 0.95), rgba(43, 108, 176, 0.9))',
          backdropFilter: 'blur(10px)'
        }}>
          <div className="card-body p-5 text-center">
            <div className="mb-3">
              <i className="fas fa-book-open fa-3x text-warning"></i>
            </div>
            <h1 className="fw-bold text-uppercase tracking-wide mb-2" style={{ fontSize: '2.2rem' }}>
              Libro Digital CASSPJS
            </h1>
            <p className="text-light-50 fs-5 mx-auto mb-4" style={{ maxWidth: '600px' }}>
              Sistema de Gestión Académica y Control Institucional. Por favor, seleccione una opción del menú superior para comenzar a trabajar.
            </p>
            <div className="text-warning small fw-semibold">
              <i className="fas fa-arrow-up animate-bounce me-2"></i> Use la barra de navegación superior para acceder a los módulos
            </div>
          </div>
        </div>

        {/* Sección de Accesos Directos Guiados */}
        <div className="row g-4 justify-content-center mb-5">
          
          {/* Módulo Libro Digital */}
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm hover-shadow bg-white text-dark text-center p-4 transition">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="rounded-circle bg-primary bg-opacity-10 p-3 mb-3 text-primary">
                  <i className="fas fa-book fa-2x"></i>
                </div>
                <h5 className="card-title fw-bold">Libro Digital</h5>
                <p className="card-text text-muted small mb-0">
                  Gestión integral de cursos, control de asistencias diarias, registro de contenidos curriculares y administración de calificaciones.
                </p>
              </div>
            </div>
          </div>

          {/* Módulo Estudiantes */}
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm hover-shadow bg-white text-dark text-center p-4 transition">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="rounded-circle bg-success bg-opacity-10 p-3 mb-3 text-success">
                  <i className="fas fa-user-graduate fa-2x"></i>
                </div>
                <h5 className="card-title fw-bold">Estudiantes</h5>
                <p className="card-text text-muted small mb-0">
                  Registro de entrevistas, bitácora de convivencia escolar, actualización de datos del estudiante e información de apoderados.
                </p>
              </div>
            </div>
          </div>

          {/* Módulo Docentes */}
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm hover-shadow bg-white text-dark text-center p-4 transition">
              <div className="card-body d-flex flex-column align-items-center">
                <div className="rounded-circle bg-info bg-opacity-10 p-3 mb-3 text-info">
                  <i className="fas fa-calendar-alt fa-2x"></i>
                </div>
                <h5 className="card-title fw-bold">Docentes</h5>
                <p className="card-text text-muted small mb-0">
                  Espacio dedicado para el seguimiento, revisión y control de las planificaciones pedagógicas de los docentes del establecimiento.
                </p>
              </div>
            </div>
          </div>

        </div>

        {/* Separación final para evitar colisiones con el footer */}
        <div className="py-3"></div>

        {/* Estilos CSS */}
        <style>{`
          .hover-shadow {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .hover-shadow:hover {
            transform: translateY(-5px);
            box-shadow: 0 .5rem 1.5rem rgba(0,0,0,.15)!important;
          }
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-4px); }
          }
          .animate-bounce {
            animation: bounce 1.5s infinite;
            display: inline-block;
          }
        `}</style>

      </div>
    </Layout>
  )
}

export default Index